import AbstractLayer from 'controllers/AbstractLayer';
import { Feature, Map as OLMap } from 'ol';
import { Geometry } from 'ol/geom';
import * as ArcGISManager from './arcgis';
import * as GeoserverManager from './geoserver';
import { RootState } from 'store';

export interface IdentifyFeaturesParams {
    layers: AbstractLayer[];
    coords: number[];
    srs?: string;
    date?: Date;
    issueTime?: Date;
    filter?: string;
    map?: OLMap;
}

export const identifyFeatures = async (
    payload: IdentifyFeaturesParams,
    state?: RootState,
): Promise<Feature<Geometry>[]> => {
    const { layers } = payload;

    const isArcGISLayer = (layerType: string | undefined) =>
        layerType === 'ImageArcGISRestLayer';

    const layerType = layers.map((l) => l.config.type).find(Boolean);

    if (isArcGISLayer(layerType)) {
        return ArcGISManager.queryFeatures(payload, state);
    }
    return GeoserverManager.queryWMSFeaturesV2(payload, state);
};
